<template>
  <div>
    <v-btn @click="dialog = true" small color="white" light class="mr-5"
      >Create Event</v-btn
    >
    <v-dialog v-model="dialog" width="500" transition="dialog-fade-transition">
      <v-card>
        <v-card-title>Create an event</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="title"
            label="Title of your event"
          ></v-text-field>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn @click="createEvent" color="primary">Save</v-btn>
          <v-btn @click="dialog = false" color="primary">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  data: () => {
    return {
      dialog: false,
      title: ""
    };
  },
  methods: {
    async createEvent() {
      await this.$store.dispatch("createEvent", {
        name: this.title
      });
      this.dialog = false;
      this.title = "";

      //this.$router.replace('/admin/settings');
    }
  }
};
</script>
